import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const singleDateFilterWrapperClass = style({
  alignItems: 'center',
  gap: spacingVars.md,
});
